import { type FC, Fragment } from 'react'
import { Box, Button, type ButtonProps, Divider, HStack, VStack } from '@chakra-ui/react'
import { type TopNavPanelItem } from 'ecosystem'
import { ContentContainer, GrandNextLink, useUIIcon } from 'ui/common'
import { useUIGlobalsContext } from 'ui/lib/ui-globals/hooks'

interface IMobileMenuSlideOutFooterProps {
  panelItems?: TopNavPanelItem[]
}

export const MenuStandardSlideOutMobileMenuFooter: FC<IMobileMenuSlideOutFooterProps> = ({
  panelItems
}) => {
  const { menuMaxContentWidth } = useUIGlobalsContext()

  if (!panelItems?.length) {
    return null
  }

  return (
    <ContentContainer direction="column" p={0} spacing={10} maxW={menuMaxContentWidth}>
      <VStack align="flex-start" w="100%">
        <Divider />
        {panelItems?.map((item, index) => (
          // eslint-disable-next-line react/no-array-index-key -- label could be the same
          <Fragment key={`${item.label}-${index}`}>
            {item.href ? (
              <Box w="100%">
                <GrandNextLink aria-label={item.label} href={item.href}>
                  <FooterMenuButton {...{ item }} />
                </GrandNextLink>
              </Box>
            ) : (
              <FooterMenuButton {...{ item }} />
            )}
          </Fragment>
        ))}
      </VStack>
    </ContentContainer>
  )
}

const FooterMenuButton: FC<ButtonProps & { item: TopNavPanelItem }> = ({ item, ...props }) => {
  const Icon = useUIIcon(item.icon)

  return (
    <Button
      _focus={{
        border: 'none'
      }}
      _hover={{
        bg: 'background.surface'
      }}
      aria-label={item.label}
      borderRadius="sm"
      color="text.default"
      fontSize="sm"
      fontWeight={400}
      size="sm"
      variant="ghost"
      w="100%"
      {...(!item?.href && {
        pointerEvents: 'none',
        color: 'text.mild'
      })}
      {...props}
    >
      <HStack justify="flex-start" spacing={4} w="100%">
        <Icon />
        <Box textAlign="center">{item.label}</Box>
      </HStack>
    </Button>
  )
}
